module.exports = __webpack_public_path__ + "static/media/PPR.17582566.svg";